<template>
  <report-page
    :title="name"
    :data-to-send="dataToSend"
    :buttons-disabled="buttonsDisabled"
    :history-filter="historyFilter"
    :selectedWorkspaceUUID="selectedWorkspace"
  >
    <template v-slot:reportForm>
      <report-field :field-name="$tc('Workspace', 1)">
        <treeselect
          v-model="selectedWorkspace"
          :options="workspaceOptions"
          :disabled="
            workspaceSelectionDisabled ||
              !userHasManagementPermission('workspace', 'list') ||
              !hasPermissionToCreateExport
          "
          disableFuzzyMatching
        />
      </report-field>

      <report-field :field-name="$tc(reportParameters[0].label, 1)">
        <treeselect
          :value="reportParameters[0].value"
          @input="updateType"
          :options="typeOptions"
          :load-options="loadTypeOptions"
          value-format="object"
          :disabled="
            !hasPermissionToCreateExport || selectedWorkspace === undefined
          "
          disableFuzzyMatching
        />
      </report-field>

      <report-field
        :field-name="$tc(reportParameters[1].label, 2)"
        v-if="needsLayerSelection"
      >
        <treeselect
          v-model="reportParameters[1].value"
          :options="objectOptions"
          :load-options="loadObjectOptions"
          :multiple="layersFieldIsMultiSelect"
          :disabled="
            !hasPermissionToCreateExport ||
              reportParameters[0].value === undefined
          "
          disableFuzzyMatching
        />
      </report-field>
    </template>
  </report-page>
</template>

<script>
import ReportPage from "../ReportPage";
import ReportField from "../ReportField";
import { mapActions } from "vuex";
import { homeReportPageMixin } from "@/mixins/homeReportPageMixin";

export default {
  name: "CoverageMapReport",

  components: {
    ReportField,
    ReportPage
  },

  mixins: [homeReportPageMixin],

  props: {
    name: {
      type: String,
      required: true
    },
    version: {
      type: String
    }
  },

  data() {
    return {
      reportParameters: [
        {
          label: "Type",
          key: "type",
          type: "text",
          value: undefined
        },
        {
          label: "Object",
          key: "layers",
          type: "text",
          value: undefined
        }
      ],

      typeOptions: null,
      objectOptions: null,

      historyFilter: "none"
    };
  },

  computed: {
    buttonsDisabled() {
      return (
        !this.reportParameters[0].value ||
        (this.needsLayerSelection && !this.reportParameters[1].value)
      );
    },

    /**
     * Determines if the Layers field should be multi-select or not.
     */
    layersFieldIsMultiSelect() {
      if (this.reportParameters[0].value === undefined) {
        return false;
      } else {
        return !this.reportParameters[0].value.just_select_one;
      }
    },

    needsLayerSelection() {
      let type = this.reportParameters[0].value;
      if (!type) {
        return false;
      }
      return type.need_select_objects;
    },

    dataToSend() {
      let type = this.reportParameters[0].value;
      if (type !== undefined) {
        return {
          type: type.type,
          version: this.version,
          objects: {
            workspace_uuid: this.selectedWorkspace,
            object: {
              uuid: this.reportParameters[1].value,
              object_type: "technical_local"
            }
          }
        };
      } else return {};
    }
  },

  watch: {
    selectedWorkspace() {
      this.resetReportParameterValues(this.reportParameters, 0);

      this.typeOptions = null;
      this.objectOptions = null;
    }
  },

  mounted() {
    this.setWorkspaceField();
    this.loadTypeOptions();
  },

  methods: {
    ...mapActions([
      "GET_EXPORT_MAPPER_TEMPLATES_BY_PAGE",
      "getObjectsToSelectInExport"
    ]),

    /**
     * Loads the list of types of file available for the selected workspace.
     */
    async loadTypeOptions() {
      let historyFilters = [];
      if (this.selectedWorkspace) {
        try {
          let types = await this.GET_EXPORT_MAPPER_TEMPLATES_BY_PAGE(
            "CoverageMapReport"
          );
          this.typeOptions = [];
          this.historyFilter = "";
          for (const type of Object.values(types)) {
            this.typeOptions.push({
              id: type.version,
              label: type.name,
              version: type.version,
              type: type.type,
              layers: type.layers,
              just_select_one: type.just_select_one,
              need_select_objects: type.need_select_objects
            });

            historyFilters.push(type.type);
          }

          this.historyFilter = historyFilters.join(",");
        } catch (error) {
          console.error(error);
        }
      }
    },

    /**
     * Loads the list of layers associated to the selected workspace and type.
     */
    updateType(e) {
      this.reportParameters[0].value = e;
      this.reportParameters[1].value = undefined;
    },

    /**
     * Loads the list of layers associated to the selected workspace and type.
     */
    loadObjectOptions({ callback }) {
      this.getObjectsToSelectInExport(this.selectedWorkspace).then(objects => {
        this.objectOptions = [];
        objects.forEach(object => {
          this.objectOptions.push({ id: object.code, label: object.name });
        });
        callback();
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/ReportsPages/CoverageMap.vue